// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + ' taşındı.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + ' eylemi tamamlandı',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + ' eylemi devam ediyor',
  accColorPalette: () => 'Renk Paleti',
  accColorSwatch: () => 'Renk Örneği',
  accCommandKey: () => 'Komut',
  accContextMenuLabel: () => 'eylemler',
  accControlKey: () => 'Kapat',
  accPositionAfter: () => 'önce',
  accPositionBefore: () => 'sonra',
  accReorderInstructions: (p: { keyPressed: string }) =>
    p['keyPressed'] +
    ' ve shift tuşlarına basılı tutun, ardından yeniden sıralamak için ok tuşlarını kullanın.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Şunun gibi tam bir tarih girin: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Şunun gibi ay ve yıl girin: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Etiket',
  chart_labelGroup: () => 'Grup',
  chart_labelSeries: () => 'Seri',
  chart_labelValue: () => 'Değer',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Bir değer seçin.',
  checkbox_helpForCheckbox: () => 'Onay kutusu için yardım',
  checkbox_requiredMessageDetail: () => 'Bir değer seçin.',
  checkbox_selected: () => 'Onay kutusu işaretli',
  checkbox_unselected: () => 'Onay kutusu işaretli değil',
  close: () => 'Kapat',
  collection_apply: () => 'Uygula',
  collection_cancel: () => 'İptal',
  collection_loaded: () => 'Yüklendi',
  collection_loading: () => 'Yükleniyor ',
  collection_noData: () => 'Görüntülenecek veri yok.',
  collection_pixels: () => 'piksel',
  collection_resizeColumnDialog: () => 'Sütunu yeniden boyutlandır',
  collection_resizeColumnMenu: () => 'Sütunu Yeniden Boyutlandır...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    p['MIN'] + ' ile ' + p['MAX'] + ' arasında bir sayı girin.',
  collection_selectAllRows: () => 'Tüm satırları seç',
  collection_selectRow: (p: { ROW_NAME: string }) => p['ROW_NAME'] + ' satırını seç',
  collection_sortAscendingSubMenu: () => 'Artan',
  collection_sortColumnMenu: () => 'Sütunu Sırala',
  collection_sortDescendingSubMenu: () => 'Azalan',
  collection_sortDisabled: () => 'Sıralanabilir değil',
  collection_sortEnabled: () => 'Sıralanabilir',
  collection_width: () => 'Genişlik',
  colorPicker_label: () => 'Renk Seçici',
  confirmation: () => 'Teyit',
  datePicker_currentDate: () => 'Geçerli tarih',
  datePicker_goToToday: () => 'Bugüne git',
  datePicker_label: () => 'Tarih Seçici',
  datePicker_month: () => 'Ay',
  datePicker_months: () => 'Ay',
  datePicker_next: () => 'Sonraki',
  datePicker_nextDecade: () => 'Sonraki on yıl',
  datePicker_nextMonth: () => 'Sonraki ay',
  datePicker_prev: () => 'Önceki',
  datePicker_prevDecade: () => 'Önceki on yıl',
  datePicker_prevMonth: () => 'Önceki ay',
  datePicker_restricted: () => 'Kısıtlı',
  datePicker_selected: () => 'Seçildi',
  datePicker_today: () => 'Bugün',
  datePicker_weekNum: (p: { NUM: string }) => 'Hafta ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Hafta Numarası',
  datePicker_year: () => 'Yıl',
  datePicker_years: () => 'Yıl',
  diagram_promotedLink: () => '1 bağlantı',
  diagram_promotedLinkAriaDesc: () => 'Dolaylı',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' bağlantı',
  error: () => 'Hata',
  expandableList_expandCollapseInstructionText: () =>
    'Genişletmek ve daraltmak için ok tuşlarını kullanın',
  expandableList_groupCollapse: () => 'Daraltıldı',
  expandableList_groupExpand: () => 'Genişletildi',
  filePicker_addFiles: () => 'Dosya Ekle',
  filePicker_dropzonePrimaryText: () => 'Sürükle ve Bırak',
  filePicker_dropzoneSecondaryText: () => 'Bir dosya seçin veya buraya bir dosya bırakın',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Dosya seçin veya buraya bırakın',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Karşıya yükleyemeyeceğiniz dosya tipleri: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Bir seferde karşıya bir tek dosya yükleyin',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Karşıya yükleyemeyeceğiniz dosya tipi: ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'bilinmeyen',
  formControl_clear: () => 'Temizle',
  formControl_day: () => 'Gün',
  formControl_empty_segment: () => 'Boş',
  formControl_helpAvailable: () => 'Yardım mevcut',
  formControl_hide: () => 'Gizle',
  formControl_hour: () => 'Saat',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    ((
      ({ one: new Intl.NumberFormat('tr').format(p['CHARACTER_LIMIT']) + ' karakter' }) as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('tr').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('tr').format(p['CHARACTER_LIMIT']) + ' karakter') +
    ' sınırına ulaştınız.',
  formControl_loading: () => 'Yükleniyor ',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'En fazla ' + p['MAX_LENGTH'] + ' karakter girebilirsiniz.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    p['MAX_LENGTH'] + ' olan maksimum uzunluk aşıldı.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' karakter kaldı.',
  formControl_millisecond: () => 'Milisaniye',
  formControl_minute: () => 'Dakika',
  formControl_month: () => 'Ay',
  formControl_readOnly: () => 'Salt okunur',
  formControl_requiredMessageDetail: () => 'Bir değer girin.',
  formControl_second: () => 'Saniye',
  formControl_selectionExactMessageDetail: (p: { n: string }) => p['n'] + ' değer seçin.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    p['max'] + ' seçim limitine ulaştınız.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    p['min'] + ' ila ' + p['max'] + ' değer seçin.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'En az ' + p['min'] + ' değer seçin.',
  formControl_show: () => 'Göster',
  formControl_year: () => 'Yıl',
  gantt_labelDate: () => 'Tarih',
  gantt_labelEnd: () => 'Bitiş',
  gantt_labelLabel: () => 'Etiket',
  gantt_labelRow: () => 'Satır',
  gantt_labelStart: () => 'Başlangıç',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Eşleşen bölüm bulunamadı.',
  indexer_keyboardInstructionText: () => 'Değer seçmek için Enter tuşuna basın.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + ' ve ' + p['TO_SECTION'] + ' arasında.',
  indexer_touchInstructionText: () =>
    'İşaret moduna girmek için çıft tıklayıp basılı tutun, ardından aşağı veya yukarı sürükleyerek değeri ayarlayın.',
  info: () => 'Bilgi',
  inputColor_selectColor: () => 'Renk seçin',
  inputDateMask_date_cleared: () => 'Tarih temizlendi',
  inputDateMask_dayPlaceholder: () => 'gg',
  inputDateMask_empty_segment: () => 'Boş',
  inputDateMask_monthPlaceholder: () => 'aa',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    p['max'] + ' ile aynı veya daha önce olan bir tarih girin.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    p['min'] + ' ile aynı veya daha sonra olan bir tarih girin.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Bir kullanılabilirlik tarihi girin.',
  inputDatePicker_instruction: () => 'Takvime erişmek için Sekme tuşuna basın.',
  inputDatePicker_selectDate: () => 'Tarih seçin',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    p['max'] + ' ile eşit veya bundan daha önce olan bir ay ve yıl girin.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    p['min'] + ' ile eşit veya bundan daha sonra olan bir ay ve yıl girin.',
  inputNumber_converterParseError: () => 'Sayı girin.',
  inputNumber_decrease: () => 'Azalt',
  inputNumber_increase: () => 'Arttır',
  inputPassword_hidden: () => 'Parola Gizli',
  inputPassword_hide: () => 'Parolayı Gizle',
  inputPassword_show: () => 'Parolayı Göster',
  inputSensitiveText_hidden: () => 'Hassas metin gizli',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    p['max'] + ' veya daha önce olan bir saat girin.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    p['min'] + ' veya daha sonra olan bir saat girin.',
  inputTimeMask_time_cleared: () => 'Tarih temizlendi',
  labelNone: () => 'Hiçbiri',
  list_msgFetchCompleted: () => 'Yüklendi',
  list_msgFetchingData: () => 'Yükleniyor ',
  list_suggestion: () => 'Öneri',
  menu_stateLoading: () => 'Yükleniyor ',
  messageToast_allMessagesClosed: () => 'Tüm durum mesajları kapatıldı.',
  message_close: () => 'Kapat',
  message_confirmation: () => 'Başarılı',
  message_error: () => 'Hata',
  message_info: () => 'Bilgi',
  message_navigationFromMessagesRegion: () =>
    'Mesajlar bölgesine giriliyor. Gezinmek için F6 tuşuna basın.',
  message_navigationToMessagesRegion: () =>
    'Mesajlar bölgesinde yeni mesajlar var. Gezinmek için F6 tuşuna basın.',
  message_navigationToTouch: () => 'Mesajlar bölgesinde yeni mesajlar var.',
  message_warning: () => 'Uyarı',
  noData_message: () => 'Görüntülenecek öğe yok',
  overflowItemLabel: () => 'Diğer Sekmeler',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Açılan pencereyi kapatmak için çift tıklayın.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Açılır pencereye giriliyor. Açılır pencere ve ilişkili kontrol arasında gezinmek için F6 tuşuna basın.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Açılır pencere açıldı. Açılır pencere ve ilişkili kontrol arasında gezinmek için F6 tuşuna basın.',
  progressIndeterminate: () => 'Devam Ediyor',
  radioButton_checked: () => 'Radyo düğmesi işaretlendi',
  radioButton_selected: () => 'Radyo düğmesi seçildi',
  radioButton_unchecked: () => 'Radyo düğmesi işaretlenmedi',
  radioButton_unselected: () => 'Radyo düğmesi seçilmedi',
  radio_helpForRadio: () => 'Radyo düğmesi yardımı',
  radio_requiredMessageDetail: () => 'Bir değer seçin.',
  selectMultiple_apply: () => 'Uygula',
  selectMultiple_back: () => 'Geri',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Seçili değerleri vurgulamak için sol ve sağ ok tuşlarını kullanın.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Seçili değeri kaldırmak için Geri veya Sil tuşuna basın.',
  selectMultiple_selectedValues: () => 'Seçili değerler',
  selectMultiple_showSelectedValues: () => 'Sadece seçili değerleri göster.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' değer seçili.',
  select_addToList: () => 'Listeye ekle',
  select_addToListAvailable: () => 'Kullanılabilir listeye ekle',
  select_closeDropdown: () => 'Kapatmak için Escape tuşuna basın.',
  select_moreSearchOptions: () => 'Diğer arama seçenekleri',
  select_moreSearchOptionsAvailable: () => 'Diğer kullanılabilir arama seçenekleri',
  select_noMatchesFound: () => 'Eşleşme bulunmadı.',
  select_oneMatchFound: () => 'Bir eşleşme bulundu',
  select_requiredMessageDetail: () => 'Bir değer seçin.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' eşleşme bulundu',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' veya daha fazla eşleşme bulundu',
  selectorAll_deselectAll: () => 'Tüm seçimleri kaldır',
  selectorAll_selectAll: () => 'Tümünü seç',
  selector_selected: () => 'Onay kutusu işaretli',
  selector_unselected: () => 'Onay kutusu işaretli değil',
  sheet_close: () => 'Kapat',
  switch_off: () => 'Kapalı',
  switch_on: () => 'Açık',
  tabBarNavigationList_removeCueText: () => 'Kaldırılabilir',
  tabBar_tabContainsErrors: () => 'Hata içeriyor',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => p['itemKey'] + ' kaldırıldı',
  tabbar_labelContextMenu: () => 'bağlam menüsü var',
  tabbar_labelMoveLeft: () => 'Sola Taşı',
  tabbar_labelMoveRight: () => 'Sağa Taşı',
  tabbar_labelRemove: () => 'Kaldır',
  timeComponent_tooltipZoomIn: () => 'Yakınlaştır',
  timeComponent_tooltipZoomOut: () => 'Uzaklaştır',
  timeConverter_parseError: () => 'Tam bir saat girin.',
  train_current: () => 'Geçerli',
  train_message_type: () => 'Mesaj Tipi',
  train_not_visited: () => 'Ziyaret edilmedi',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Adım ' + p['currentStep'] + ' / ' + p['numberOfSteps'],
  train_visited: () => 'Ziyaret edildi',
  userAssistance_learnMore: () => 'Daha fazla bilgi edinin',
  userAssistance_required: () => 'Gerekli',
  vis_clearSelection: () => 'Seçimi Temizle',
  vis_drillable: () => 'Detaylandırılabilir',
  vis_invalidData: () => 'Geçersiz veri',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + '/' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Çerçeve seçimi',
  vis_marqueeZoomTooltip: () => 'Çerçeve yakınlaştırma',
  vis_noData: () => 'Görüntülenecek veri yok',
  vis_panTooltip: () => 'Kaydır',
  vis_stateCollapsed: () => 'Daraltıldı',
  vis_stateExpanded: () => 'Genişletildi',
  vis_stateLoaded: () => 'Yüklendi',
  vis_stateLoading: () => 'Yükleniyor ',
  vis_stateSelected: () => 'Seçildi',
  vis_stateUnselected: () => 'Seçim Kaldırıldı',
  warn: () => 'Uyarı'
};
export default bundle;
